import { ComponentPropsWithRef } from "react";

export const PauseIcon = ({ ref, ...props }: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM12.5 12C12.5 11.7239 12.7239 11.5 13 11.5H14.625C14.9011 11.5 15.125 11.7239 15.125 12V20C15.125 20.2761 14.9011 20.5 14.625 20.5H13C12.7239 20.5 12.5 20.2761 12.5 20V12ZM17.375 11.5C17.0989 11.5 16.875 11.7239 16.875 12V20C16.875 20.2761 17.0989 20.5 17.375 20.5H19C19.2761 20.5 19.5 20.2761 19.5 20V12C19.5 11.7239 19.2761 11.5 19 11.5H17.375Z"
      fill="currentColor"
    />
  </svg>
);
